// extracted by mini-css-extract-plugin
export default {"truncateContainer":"Truncate_truncateContainer__IR1p4","truncate":"Truncate_truncate__26FIw","button":"Truncate_button__qGxIN"};